import { targetClasses } from 'src/js/modules/element-settings/constants/target-classes';

export const borderTargets = [
  targetClasses.BORDER_TOP,
  targetClasses.BORDER_RIGHT,
  targetClasses.BORDER_BOTTOM,
  targetClasses.BORDER_LEFT,
];

export const cornerTargets = [
  targetClasses.ROUNDED_TOP_LEFT,
  targetClasses.ROUNDED_TOP_RIGHT,
  targetClasses.ROUNDED_BOTTOM_LEFT,
  targetClasses.ROUNDED_BOTTOM_RIGHT,
];
export const shadowTargets = [targetClasses.OUTER_SHADOW];

export const verticalSpacingTargets = [targetClasses.PADDING_TOP, targetClasses.PADDING_BOTTOM];

export const horizontalSpacingTargets = [
  targetClasses.COL_PADDING_LEFT,
  targetClasses.COL_PADDING_RIGHT,
];

export const horizontalGapTargets = [targetClasses.COLS_GAP_X];

export const verticalGapTargets = [targetClasses.GAP_Y];

export const autoPaddingTargets = [
  targetClasses.AUTO_PADDING_TOP,
  targetClasses.AUTO_PADDING_BOTTOM,
  targetClasses.AUTO_COL_PADDING_LEFT,
  targetClasses.AUTO_COL_PADDING_RIGHT,
];

export const columnsOrderTargets = [targetClasses.FLEX_DIRECTION, targetClasses.FLEX_WRAP];
export const columnsOrderDirectionTargets = [targetClasses.FLEX_DIRECTION];
